import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { UpdateDocumentInternalAuditResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateDocumentInternalAuditResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export type UpdateDocumentInternalAuditResultInput = {
  Id: string;
  Rating?: number | null;
  Rationale?: string | null;
  TestDate?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useUpdateDocumentInternalAuditResult = createMutationHook({
  name: 'updateDocumentInternalAuditResult',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.internalAuditResult.updateDocument.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: UpdateDocumentInternalAuditResultInput) => input,
  // The tRPC update returns the updated Id; the async mutation always affects the
  // single targeted row, so we report affected_rows: 1 to preserve the GraphQL
  // consumer's `affected_rows === 0` failure check.
  mapResponse: (): UpdateDocumentInternalAuditResultMutation => ({
    update_document_internal_audit_result: {
      __typename: 'document_internal_audit_result_mutation_response',
      affected_rows: 1,
    },
  }),
  invalidate: (trpc) => [
    trpc.frontend.internalAuditResult.pathKey(),
    trpc.frontend.assessment.internalAuditResultCount.queryKey(),
    // COI-471 parity: Apollo twin also evicts `internal_audit_report`.
    trpc.frontend.internalAuditReport.pathKey(),
  ],
  graphqlDocument: UpdateDocumentInternalAuditResultDocument,
  graphqlVariables: (input: UpdateDocumentInternalAuditResultInput) => ({
    ...input,
  }),
  evictFields: [
    'document_internal_audit_result',
    'internal_audit_report',
    'document_internal_audit_result_aggregate',
  ],
});
